{
	"_comment": "This file is updated by the build process. Do not edit it manually.",
	"version": "1.80.2",
	"hash": "3f217136c26026a9c891b7c535df1d149647f24c"
}
